import type { ColumnDef } from "@tanstack/react-table";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/data-table";
import type { SampleError } from "@/services/backend/sample-error/sample-error";
import { useListSampleErrorsQuery } from "@/services/backend/sample-error/service";
import { evaluableTypes } from "@/shared/components/enum-labels";
import { EditErrorDialog } from "./edit-error-dialog";
import DeleteErrorButton from "./delete-error-button";

const tableColumns: ColumnDef<SampleError>[] = [
  {
    id: "Beschreibung",
    accessorKey: "description",
    header: "Beschreibung",
    cell: ({ row }) => {
      const sampleErrorData = row.original;
      return <div>{sampleErrorData.description}</div>;
    },
  },
  {
    id: "Auswertbarkeit",
    accessorKey: "evaluableType",
    header: "Auswertbarkeit",
    cell: ({ row }) => {
      const sampleErrorData = row.original;
      return <div>{evaluableTypes[sampleErrorData.evaluableType]}</div>;
    },
  },
  {
    id: "Optionen",
    accessorKey: "id",
    header: "Optionen",
    cell: ({ row }) => (
      <div className="flex flex-row items-center space-x-2">
        <EditErrorDialog sampleError={row.original} />
        <DeleteErrorButton errorId={row.original.id} />
      </div>
    ),
  },
];

export function SampleErrorListTable() {
  const {
    data: list,
    isLoading,
    isFetching,
    error,
  } = useListSampleErrorsQuery(
    {},
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const table = useDataTableController(tableColumns, list?.items || []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <DataTableContainer>
      <DataTable
        table={table}
        columns={tableColumns}
        isLoading={isLoading || isFetching}
      />
    </DataTableContainer>
  );
}
